import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyledHeader } from './components/header/header-style';
import { ToggleSwitch, Tabs } from '@oneaudi/unified-web-components';
import { useI18n } from './i18n/i18n';
import { useCarlineStore } from './store/carline';
import { StandardEquipment } from './components/standard-equipment/standard-equipment';
import { TechData } from './components/tech-data/tech-data';
import { useModelTechnicalDataSection } from './hooks/use-technical-data-sections';
export const App = ({ actions }) => {
    const { compare, setCompare, appConfig: config, selectedEngine } = useCarlineStore();
    const techData = useModelTechnicalDataSection(selectedEngine === null || selectedEngine === void 0 ? void 0 : selectedEngine.technicalDataV2);
    const { i18n } = useI18n();
    const tabIndexToTabName = ['standardEquipment', 'technicalData'];
    return (_jsxs(StyledHeader, { hideTabs: config === null || config === void 0 ? void 0 : config.hideTabs, children: [_jsx("div", { className: "toggle-switch-container", children: !(config === null || config === void 0 ? void 0 : config.isDisabled) && (_jsx(ToggleSwitch, { checked: compare, "data-testid": "compare-toggle-switch", id: "compare-toggle-switch", label: i18n('compareLayer.header.compare'), labelPosition: "leading", name: "compare-toggle-switch", onChange: (e) => {
                        setCompare(e.target.checked);
                    }, value: "compare-toggle-switch" })) }), _jsx(Tabs, { items: [
                    {
                        label: i18n('compareLayer.header.standardEquipment'),
                        content: (config === null || config === void 0 ? void 0 : config.selectedTab) === 'standardEquipment' ? (_jsx(StandardEquipment, { actions: actions })) : (_jsx("div", {})),
                        active: (config === null || config === void 0 ? void 0 : config.selectedTab) === 'standardEquipment',
                        onClick: () => {
                            var _a;
                            (_a = actions === null || actions === void 0 ? void 0 : actions.onChangeActiveTab) === null || _a === void 0 ? void 0 : _a.call(actions, 'standardEquipment');
                        },
                    },
                    {
                        label: i18n('compareLayer.header.technicalData'),
                        content: (config === null || config === void 0 ? void 0 : config.selectedTab) === 'technicalData' ? _jsx(TechData, { actions: actions }) : _jsx("div", {}),
                        active: (config === null || config === void 0 ? void 0 : config.selectedTab) === 'technicalData',
                        onClick: () => {
                            var _a;
                            (_a = actions === null || actions === void 0 ? void 0 : actions.onChangeActiveTab) === null || _a === void 0 ? void 0 : _a.call(actions, 'technicalData');
                        },
                        disabled: !techData || !techData.length,
                    },
                ], id: "header-tabs", size: "md", className: "tabs", onKeyNavigate: (newIndex) => {
                    var _a;
                    const tabName = tabIndexToTabName[newIndex];
                    if (tabName) {
                        (_a = actions === null || actions === void 0 ? void 0 : actions.onChangeActiveTab) === null || _a === void 0 ? void 0 : _a.call(actions, tabName);
                    }
                }, scrollButtons: {
                    left: {
                        ariaLabel: 'Scroll left',
                    },
                    right: {
                        ariaLabel: 'Scroll right',
                    },
                } })] }));
};
